import {
  MockMap,
} from '@ama-sdk/core';
import {
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  CheckInFlightIdObjectRepository,
  combineCheckInFlightIdObjects,
  combineJourneyElementCommons,
  combineJourneyTravelers,
  createBoardingPassResult,
  createJourney,
  createMockData,
  createMockDataWithResponse,
  JourneyTravelerRepository,
} from '@dapi/sdk/spec';

const journey = createJourney({
  template: {
    type: 'standalone',
    travelers: combineJourneyTravelers([JourneyTravelerRepository.WOMAN, JourneyTravelerRepository.MAN]).items,
    flights: combineCheckInFlightIdObjects([CheckInFlightIdObjectRepository.FRA_NCE, CheckInFlightIdObjectRepository.NCE_FRA]).items,
    journeyElements: combineJourneyElementCommons([
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-0-MOCK'
          },
          flightId: 'CHECK-IN-FLIGHT-0-MOCK'
        }
      },
      {
        journeyElement: {
          traveler: {
            id: 'JOURNEY-TRAVELER-1-MOCK'
          },
          flightId: 'CHECK-IN-FLIGHT-0-MOCK'
        }
      }
    ]).items,
    acceptance: {
      isAccepted: true
    }
  }
});

const journeyElementIds = journey.journeyElements.map((je: JourneyElementCommon) => je.id);
/**
 * Deeplink Boarding pass
 * Multi Flights - Multi paxes
 */
export const deeplinkMultiFlightsMultiPaxBP: MockMap = {
  generateBoardingPasses: [createMockDataWithResponse([createBoardingPassResult({
    template: {
      result: 'returnedBoardingPassData',
      journeyElementIds
    }
  })], 201)],
  retrieveJourney: [createMockData(journey)]
};
